import { FoodsTags } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

export type ValidatedState = "validated" | "incomplete" | null | undefined;

type ValidatedTagProps = {
    state?: ValidatedState;
};
export const ValidatedTag = (props: ValidatedTagProps) => {
    const { state = null } = props;
    const { t } = useTranslation();

    if (state === null || state === undefined) return null;

    if (state === "incomplete") {
        return (
            <FoodsTags
                label={t("component.tags.incomplete", "Incomplete questionnaire")}
                startIcon="warning"
                variant="tags-red"
                disabled
                sx={{
                    minWidth: "fit-content",
                    flexShrink: 0,
                }}
            />
        );
    }

    return (
        <FoodsTags
            label={t("component.tags.is_validated", "Validated questionnaire")}
            startIcon="check"
            variant="tags-green"
            disabled
            sx={{
                minWidth: "fit-content",
                flexShrink: 0,
            }}
        />
    );
};
